export const FRONTEGG_AFTER_AUTH_REDIRECT_URL = 'FRONTEGG_AFTER_AUTH_REDIRECT_URL';
export const HOSTED_LOGIN_VERIFIER_KEY = 'HOSTED_LOGIN_VERIFIER_KEY';
export const authStoreName = 'auth';
export const impersonationStoreName = 'impersonation';
export const connectivityStoreName = 'connectivity';
export const auditsStoreName = 'auditLogs';
export const subscriptionsStoreName = 'subscriptions';
export const vendorStoreName = 'vendor';